/* eslint-disable import/prefer-default-export */
import { select } from 'redux-saga/effects'
import { selectUid } from '../../selectors'

export function* selectItemOwnByKey(params) {
	const stateItemOwnByKey = yield select(state => state.itemOwnByKey)
	return {
		...params,
		stateItemOwnByKey
	}
}

export function* getParamsForItemFetch(params) {
	const uid = yield select(selectUid)
	return {
		...params,
		uid
	}
}



// WEBPACK FOOTER //
// ./src/redux/saga/items/sagas.js